// Device location captured for the GRN acceptance certificate. Resolves undefined when the browser
// has no geolocation, the page is insecure, or the user blocks / times out the permission prompt.
const getCurrentGeo = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation || !window.isSecureContext) {
      return resolve(undefined);
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude, source: 'gps' }),
      () => resolve(undefined),
      { timeout: 8000, maximumAge: 60000, enableHighAccuracy: true }
    );
  });

const GEO_REQUIRED_MESSAGE = 'Location access is required to receive this dispatch. Please allow location permission for this site in your browser and try again.';

export { getCurrentGeo, GEO_REQUIRED_MESSAGE };
